import { withTypeSafeApiResult } from '@/packages/typesafe-result';

import {
  type IApiGeoGeocodeCachedRequest,
  type IApiGeoGeocodeCachedResponse,
  fetchApiGeoGeocodeCached,
} from '@/repositories/generated/shared/monolith-cian-realty/api/geo/geocode-cached';

export const fetchGeocodeCached = withTypeSafeApiResult<IApiGeoGeocodeCachedRequest, IApiGeoGeocodeCachedResponse>(
  fetchApiGeoGeocodeCached,
);
